import React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "../../../lib/utils";

const BADGE_CLASSES = {
  Receipt: "bg-emerald-50 text-emerald-700 border-emerald-200/40",
  Return: "bg-blue-50 text-blue-700 border-blue-200/40",
  "Transfer In": "bg-cyan-50 text-cyan-700 border-cyan-200/40",
  "Transfer Out": "bg-orange-50 text-orange-700 border-orange-200/40",
  Reservation: "bg-purple-50 text-purple-700 border-purple-200/40",
  Outward: "bg-rose-50 text-rose-700 border-rose-200/40",
  Revocation: "bg-gray-50 text-gray-700 border-gray-250",
  "Defect Adjustment": "bg-amber-50 text-amber-700 border-amber-200/40",
};

const MOVEMENT_TYPE_KEYS = {
  Receipt: "inventory.movementReceipt",
  Return: "inventory.movementReturn",
  "Transfer In": "inventory.movementTransferIn",
  "Transfer Out": "inventory.movementTransferOut",
  Reservation: "inventory.movementReservation",
  Outward: "inventory.movementOutward",
  Revocation: "inventory.movementRevocation",
  "Defect Adjustment": "inventory.movementDefectAdjustment",
};

export function MovementTypeBadge({ type }) {
  const { t } = useTranslation();
  const labelKey = MOVEMENT_TYPE_KEYS[type];

  return (
    <span
      className={cn(
        "inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-bold border whitespace-nowrap",
        BADGE_CLASSES[type] || "bg-gray-50 text-gray-700 border-gray-200"
      )}
    >
      {labelKey ? t(labelKey) : type}
    </span>
  );
}
